import { getThreatProtectionScriptSrc } from '@/shared/lib/cognito-threat-protection';

export function ThreatProtectionScript() {
    const src = getThreatProtectionScriptSrc();
    if (!src) return null;

    return <script async src={src} />;
}
